<ng-container *ngIf="isElementAllowed(element)">
  <a mat-list-item *ngIf="element.route" (click)="panel.toggle()" routerLinkActive="selected"
    [routerLinkActiveOptions]="{exact: element.routerActiveExact}" class="element side-nav-link"
    id="{{ element.name }}" 
    [ngStyle]="{'padding-left': getPadding()}" [routerLink]="element.route" [queryParams]="element.queryParams">
    @if (element.isSvgIcon) {
      <mat-icon matListItemIcon *ngIf="element.icon" class="align-middle" [svgIcon]="element.icon"></mat-icon>
    } @else {
      <mat-icon matListItemIcon *ngIf="element.icon" class="align-middle">{{ element.icon }}</mat-icon>
    }
    <span
      [class.header-item]="!!element.elements && !element.icon">{{ element.name | translate:locale.language }}</span>
    <span style="flex: auto"></span>
  </a>

  <mat-list-item *ngIf="!element.route" (click)="panel.toggle()" class="element" id="{{ element.name }}" [ngStyle]="{'padding-left': getPadding()}"
    matTooltip="Click to expand {{ element.name | translate:locale.language }}" [matTooltipDisabled]="!(!panel.expanded && !!element.elements)" matTooltipPosition="after">
    @if (element.isSvgIcon) {
      <mat-icon matListItemIcon *ngIf="element.icon" class="align-middle" [svgIcon]="element.icon"></mat-icon>
    } @else {
      <mat-icon matListItemIcon *ngIf="element.icon" class="align-middle">{{ element.icon }}</mat-icon>
    }
    <span matListItemTitle
      [class.header-item]="!!element.elements && !element.icon">{{ element.name | translate:locale.language }}</span>
    <span style="flex: auto"></span>
    <span matListItemMeta>
      <button mat-icon-button *ngIf="!!element.elements" [attr.aria-label]="(panel.expanded ? 'Collapse ' : 'Expand ') + (element.name | translate:locale.language)">
        <mat-icon>{{ panel.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </span>
  </mat-list-item>

  <div [class.hidden]="!element.elements?.length" [class.nested]="nested">
    <mat-expansion-panel #panel="matExpansionPanel" [class.hidden]="!element.elements?.length"
      class="mat-elevation-z0" [expanded]="element.expanded != null && !isInRoute ? element.expanded : true">
      <div *ngIf="!!element.elements">
        <app-nav-element [nested]="nested" *ngFor="let ele of element.elements" [element]="ele" [level]="level+1">
        </app-nav-element>
      </div>
    </mat-expansion-panel>
  </div>
</ng-container>